/**
 * UUIDv7, in fifteen lines and no dependency.
 *
 * The lab engine mints event ids in the browser, and those ids are the whole
 * offline story: they are the primary key `POST /learn/events` upserts on, so a
 * batch resent after a flaky reconnect writes nothing new. Version 7 rather
 * than 4 because the first 48 bits are the timestamp, which means the event log
 * sorts by creation time without a sequence a disconnected client cannot get.
 *
 * A dependency would be reasonable; this is smaller than the import statement's
 * share of the bundle, and this bundle ships to feature phones.
 */
let lastMillis = 0;
let sequence = 0;
export function uuidv7() {
    const now = Date.now();
    // Two events in the same millisecond must not collide, and must still sort in
    // the order they happened — a learner clicking a tally can produce several
    // per millisecond. The counter goes into the first random block.
    if (now === lastMillis)
        sequence += 1;
    else {
        lastMillis = now;
        sequence = 0;
    }
    const bytes = new Uint8Array(16);
    const random = crypto.getRandomValues(new Uint8Array(10));
    bytes[0] = (now / 2 ** 40) & 0xff;
    bytes[1] = (now / 2 ** 32) & 0xff;
    bytes[2] = (now / 2 ** 24) & 0xff;
    bytes[3] = (now / 2 ** 16) & 0xff;
    bytes[4] = (now / 2 ** 8) & 0xff;
    bytes[5] = now & 0xff;
    bytes[6] = 0x70 | ((sequence >> 8) & 0x0f);
    bytes[7] = sequence & 0xff;
    bytes[8] = 0x80 | (random[2] & 0x3f);
    for (let index = 9; index < 16; index += 1)
        bytes[index] = random[index - 6];
    const hex = [...bytes].map(byte => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
//# sourceMappingURL=uuidv7.js.map